import { SidebarDisplayTypes } from 'src/enums/sidebar.display.types';
import {
    SystemActionTypes,
    START_FETCHING,
    STOP_FETCHING,
    TOGGLE_ERROR_MODAL,
    TOGGLE_SUCCESS_MODAL,
    TOGGLE_SIDEBAR,
} from './types';

export function startFetching(): SystemActionTypes {
    return {
        type: START_FETCHING,
    };
}

export function stopFetching(): SystemActionTypes {
    return {
        type: STOP_FETCHING,
    };
}

export function toggleErrorModal(title?: string, content?: string): SystemActionTypes {
    return {
        type: TOGGLE_ERROR_MODAL,
        payload: { title, content },
    };
}

export function toggleSuccessModal(title?: string, content?: string): SystemActionTypes {
    return {
        type: TOGGLE_SUCCESS_MODAL,
        payload: { title, content },
    };
}

export function toggleSidebar(
    sidebar: SidebarDisplayTypes.SIDEBAR_DISPLAY_BLOCK | SidebarDisplayTypes.SIDEBAR_DISPLAY_NONE | undefined,
): SystemActionTypes {
    return {
        type: TOGGLE_SIDEBAR,
        payload: { sidebar },
    };
}
